import { render, staticRenderFns } from "./WidgetQCInspection.vue?vue&type=template&id=f1f44296"
import script from "./WidgetQCInspection.vue?vue&type=script&lang=js"
export * from "./WidgetQCInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports